export const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  DEFAULT_FROM_DATE: process.env.REACT_APP_DEFAULT_FROM_DATE || '',
  REALTIME_GATEWAY_URL: process.env.REACT_APP_REALTIME_GATEWAY_URL || '',
  REALTIME_CLOUD_HOST: process.env.REACT_APP_REALTIME_CLOUD_HOST || '',
  MEMBERS_APP_URL: process.env.REACT_APP_MEMBERS_APP_URL || '',
  LOGIN_BACKGROUND_URL: process.env.REACT_APP_LOGIN_BACKGROUND_URL || '',
  DEFAULT_LOGO_URL: process.env.REACT_APP_DEFAULT_LOGO_URL || '',
  INTERNAL_EMAIL_DOMAIN: process.env.REACT_APP_INTERNAL_EMAIL_DOMAIN || '',
} as const;
